import { render, staticRenderFns } from "./SignInModal.vue?vue&type=template&id=5af13bce&scoped=true"
import script from "./SignInModal.vue?vue&type=script&lang=ts"
export * from "./SignInModal.vue?vue&type=script&lang=ts"
import style0 from "./SignInModal.vue?vue&type=style&index=0&id=5af13bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af13bce",
  null
  
)

export default component.exports